module.exports = __webpack_public_path__ + "img/ring_r_0_null_1@2x.748e0a39.png";